import http from 'utils/http';
import {
  getChunkUrls,
  getChunksUrls,
  getCloneKnowledgeBaseUrl,
  getDataSetUrls,
  getDataSetsUrls,
  getImportQaChunkUrls,
  getKnowledgeBaseUrl,
  getKnowledgeBasesUrl,
  getRetrieveChunkUrl
} from './apiUrls';
import { KnowledgeBaseRequest, KnowledgeBaseResponse } from 'apis/business/types';
import { ChunkResponse, DatasetResponse } from './types';
import { MetaApiResponse } from 'utils/types/CommonApiResponse';

export function getKnowledgeBases(
  searchText?: string | null
): Promise<{ data: KnowledgeBaseResponse[]; meta: MetaApiResponse }> {
  return http.get(getKnowledgeBasesUrl(), { 'filter[name_cont]': searchText });
}

export function getKnowledgeBase(id: string): Promise<KnowledgeBaseResponse> {
  return http.get(getKnowledgeBaseUrl(id));
}

export function deleteKnowledgeBase(id: string): Promise<{ data: KnowledgeBaseResponse[] }> {
  return http.delete(getKnowledgeBaseUrl(id));
}

export function createKnowledgeBase(payload: KnowledgeBaseRequest): Promise<KnowledgeBaseResponse> {
  return http.post(getKnowledgeBasesUrl(), payload);
}

export function updateKnowledgeBase(id: string, payload: KnowledgeBaseRequest): Promise<KnowledgeBaseResponse> {
  return http.patch(getKnowledgeBaseUrl(id), payload);
}

export function cloneKnowledgeBase(id: number): Promise<KnowledgeBaseResponse> {
  return http.post(getCloneKnowledgeBaseUrl(id));
}

export function getDataSets(
  knowledgeBaseId: string,
  params: any
): Promise<{ data: DatasetResponse[]; meta: MetaApiResponse }> {
  return http.get(getDataSetsUrls(knowledgeBaseId), params);
}

export function getDataSet(knowledgeBaseId: string, dataSetId: string): Promise<DatasetResponse> {
  return http.get(getDataSetUrls(knowledgeBaseId, dataSetId));
}

// TODO need to update the any for payload
export function createDataSet(knowledgeBaseId: string, payload: any): Promise<any> {
  return http.post(getDataSetsUrls(knowledgeBaseId), payload);
}

export function updateDataSet(knowledgeBaseId: string, dataSetId: string, payload: any): Promise<any> {
  return http.put(getDataSetUrls(knowledgeBaseId, dataSetId), payload);
}

export function deleteDataSet(knowledgeBaseId: string, id: string): Promise<String> {
  return http.delete(getDataSetUrls(knowledgeBaseId, id));
}

export function getRetrieveChunk(knowledgeBaseId: string, data: any): Promise<any> {
  return http.get(getRetrieveChunkUrl(knowledgeBaseId), data);
}

export async function getChunks(
  knowledgeBaseId: string,
  datasetId: string,
  params?: any
): Promise<{ data: ChunkResponse[]; meta: MetaApiResponse }> {
  const res = await http.get(getChunksUrls(knowledgeBaseId, datasetId), params);
  return {
    data: res?.data,
    meta: {
      count: res?.count ?? res?.per_page ?? 0,
      total_count: res?.total_count ?? res?.total ?? 0,
      total_pages: res?.total_pages ?? 0
    }
  };
}

export function getChunk(knowledgeBaseId: string, dataSetId: string, chunkId: string): Promise<ChunkResponse> {
  return http.get(getChunkUrls(knowledgeBaseId, dataSetId, chunkId));
}

export function createChunk(
  knowledgeBaseId: string,
  dataSetId: string,
  payload: KnowledgeBaseRequest
): Promise<ChunkResponse> {
  return http.post(getChunksUrls(knowledgeBaseId, dataSetId), payload);
}

export function updateChunk(
  knowledgeBaseId: string,
  dataSetId: string,
  chunkId: string,
  payload: KnowledgeBaseRequest
): Promise<ChunkResponse> {
  return http.put(getChunkUrls(knowledgeBaseId, dataSetId, chunkId), payload);
}

export function deleteChunk(knowledgeBaseId: string, dataSetId: string, chunkId: string): Promise<String> {
  return http.delete(getChunkUrls(knowledgeBaseId, dataSetId, chunkId));
}

export function importQaChunk(knowledgeBaseId: string, dataSetId: string, payload: FormData): Promise<ChunkResponse> {
  return http.post(getImportQaChunkUrls(knowledgeBaseId, dataSetId), payload);
}
